import * as React from 'react';
import { FixedSizeGrid } from 'react-window';
import { FileItemInfo } from '../../../sic-lib/types/FileItemInfo';
import { AutoSize } from '../../Shared/AutoSize';
import SicMediaTabItem from './SicMediaTabItem';

interface Props {
    files: FileItemInfo[];
}

export default React.memo(function SicMediaTab({ files }: Props) {
    return (
        <AutoSize>
            {size => {
                const columCount = Math.floor(size.width / 240);
                const rowCount = Math.ceil(files.length / columCount);
                return (
                    <FixedSizeGrid
                        height={size.height}
                        width={size.width}
                        columnWidth={240}
                        columnCount={columCount}
                        rowCount={rowCount}
                        rowHeight={240}
                        itemData={files}
                    >
                        {({
                            columnIndex,
                            rowIndex,
                            style,
                            data,
                        }: {
                            columnIndex: number;
                            rowIndex: number;
                            style: React.CSSProperties;
                            data: FileItemInfo[];
                        }) => {
                            const index = rowIndex * columCount + columnIndex;
                            const file = data[index];
                            if (index >= files.length) return null;

                            return (
                                <div
                                    style={style}
                                    key={data[rowIndex * columCount + columnIndex].fileName}
                                >
                                    <SicMediaTabItem data={file} />
                                </div>
                            );
                        }}
                    </FixedSizeGrid>
                );
            }}
        </AutoSize>
    );
});
